module.exports = __webpack_public_path__ + "src/app/_content/MOTFonts/BMWMotorradW01-Bold.woff2?efee310048f2d13028b0aa455b9e5c68";